import { enterpriseFieldProps } from 'components/fields/EnterpriseField';
import { createEntityFilterChip } from './createEntityFilterChip';

export const EnterpriseFilterChip = createEntityFilterChip('core/enterprises/', {
  ...enterpriseFieldProps,
  eager: true,
});
